import styled from 'styled-components';
import { colors } from '../../Components/StylesGlobales/Colors';

export const ContainerAboutMe = styled.div`
  padding-top: 7rem;
  margin: 0 auto;
`;

export const ContainerFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0 2rem;
  }
`;

export const ContainerText = styled.div`
  font-size: 2rem;
  padding: 0 2rem;
  text-align: center;
  font-weight: 700;

  @media (max-width: 768px) {
    padding: 0;
    font-size: 1.5rem;
  }
`;

export const Title = styled.h1`
  margin: 0;
  padding: 3rem 0;

  p:nth-child(2) {
    font-size: 3rem;
    line-height: 2.4rem;
    background: ${colors.TEXT_GRADIENT_PURPLE};
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    @media (max-width: 768px) {
      font-size: 2.5rem;
    }
  }

  @media (max-width: 768px) {
    padding: 0;

    p:nth-child(3) {
      font-size: 1.5rem;
    }
  }
`;

export const DescriptionText = styled.div`
  font-size: 1rem;
  padding-bottom: 1rem;
  color: ${colors.TEXT_GREY_NEUTRAL};
`;

export const ContainerImage = styled.div`
  max-width: 250px;
  img {
    width: 250px;
    margin: 0 auto;
    border-radius: 50%;
  }
  @media (max-width: 768px) {
    width: 80%;
    padding: 10px 0;
    img {
      width: 80%;
    }
  }
`;
